export default __webpack_public_path__ + "static/media/empty-user-desc.78f54425.png";